import App from "./App";
import {useState} from "react";
import {Button} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Footer from "@components/legal/Footer";
import DataProtection from "@components/legal/DataProtection";

export default function AppWithManualUserId() {

    const [userId, setUserId] = useState('')
    const [submitted, setSubmitted] = useState(false)
    const [showDataProtection, setShowDataprotection] = useState(false)

    const submitUserId = () => {
        //TODO: Check with full user list or generic rule
        setSubmitted(true)
    }

    const submitForm = (ke) => {
        if(ke.key === "Enter") {
            submitUserId()
        }
    }


    const inputField =  (<Grid component="span" m={5} style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>
        <h2>Bitte gebe deinen persönlichen Code ein:</h2>
        <TextField id="userId" label="Dein persönlicher Code" variant="outlined" onChange={e => setUserId(e.target.value)} onKeyUp={submitForm}/>
        <Button onClick={submitUserId} color="primary">Weiter</Button>
    </Grid>)

    const dataProtection = <>
    <DataProtection/>
    <Button onClick={() => setShowDataprotection(false)} color="primary">Datenschutzerklärung ausblenden</Button>
    </>

    const inputFieldPage = (<>
        <main>
            {showDataProtection ? dataProtection : inputField}
        </main>
        <Footer showDataProtection={() => setShowDataprotection(true)}/>
    </>);

    if(submitted) {
        return <App userId={userId}/>
    } else {
        return inputFieldPage
    }
}